<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('lineItems.productNumber')"
    class="shipment-product-number-filter w-2"
    optional
  >
    <InputText
      :id="inputId"
      v-model="internalValue.productNumber"
      :placeholder="t('lineItems.productNumber')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import InputText from 'primevue/inputtext';

const internalValue = defineModel<ShipmentSearchCriteria>('modelValue', {
  type: ShipmentSearchCriteria,
  default: () => new ShipmentSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
const { t } = useI18n();
</script>
